<template>
  <!-- App-wide dropdown (instead of a native <select>): the project customDropdown with one look
       (Tailwind border-[1px], not Bootstrap's `border`: its !important colour would beat border-[#E1E5EF] and an error red)
       (checkout "Financial Institution" style). v-model + @change(value) like a <select>. -->
  <customDropdown :model-value="modelValue" :items="items" :label-key="labelKey" :value-key="valueKey"
    :button-text="placeholder" :disabled="disabled"
    :button-warpper-class="['relative w-full', wrapperClass]"
    :button-class="['!rounded-[8px] border-solid border-[1px] border-[#E1E5EF] flex items-center justify-between gap-[8px] px-[12px] w-full bg-white text-left disabled:!bg-[#F7F8FA] disabled:cursor-not-allowed', small ? '!h-[34px]' : '!h-[40px]', buttonClass]"
    :button-text-class="['font-roboto truncate', small ? 'text-[13px]' : 'text-[14px]', hasValue ? 'text-[#333333]' : 'text-[#AAAAAA]']"
    :button-icon-class="'hidden'"
    :button-dropdown-icon="'flex-shrink-0 flex items-center text-[#5B616B]'"
    floating
    :dropdown-list-class="'z-[1080] rounded-[8px] border border-[#E1E5EF] bg-white shadow-[0px_4px_12px_0px_#0000001A] overflow-hidden'"
    :dropdown-list-l-i-class="'hover:bg-[#F3F4F7]'"
    :dropdown-list-anchor-class="'no-underline font-roboto block px-[12px] py-[10px] text-[13px] cursor-pointer text-[#333333] hover:bg-[#F3F4F7]'"
    @update:model-value="onPick" />
</template>

<script>
import customDropdown from "./customDropdown.vue";

export default {
  components: { customDropdown },
  props: {
    modelValue: { type: [String, Number, Object, Boolean], default: null },
    // [{ label, value }] — or any objects with labelKey / valueKey
    options: { type: Array, default: () => [] },
    labelKey: { type: String, default: "label" },
    valueKey: { type: String, default: "value" },
    placeholder: { type: String, default: "Select" },
    disabled: { type: Boolean, default: false },
    // no longer used: the list always floats over the page (customDropdown "floating"), never pushing content down
    inline: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    wrapperClass: { type: [String, Array, Object], default: "" },
    buttonClass: { type: [String, Array, Object], default: "" },
  },
  emits: ["update:modelValue", "change"],
  computed: {
    items() {
      return Array.isArray(this.options) ? this.options : [];
    },
    hasValue() {
      return this.items.some(o => this.valueKey === "object"
        ? JSON.stringify(o) === JSON.stringify(this.modelValue)
        : this.modelValue != null && String(o[this.valueKey]) === String(this.modelValue));
    },
  },
  methods: {
    onPick(value) {
      this.$emit("update:modelValue", value);
      this.$emit("change", value);
    },
  },
};
</script>
